export interface Department {
  id: number;
  name: string;
  description: string;
  cityCapitalId: number;
  municipalities: number;
  surface: number;
  population: number;
  phonePrefix: string;
  countryId: number;
  cityCapital: null;
  country: null;
  cities: null;
  regionId: number;
  region: null;
  naturalAreas: null;
  maps: null;
  indigenousReservations: null;
  airports: null;
}

export interface City {
  id: number;
  name: string;
  departmentId: number;
  department: null;
  touristAttractions: null;
  presidents: null;
}

const API_URL = "https://api-colombia.com/api/v1";

export const LocationService = {
  getDepartments: async (): Promise<Department[]> => {
    try {
      const response = await fetch(`${API_URL}/Department`);
      if (!response.ok) {
        throw new Error("Failed to fetch departments");
      }
      const data = await response.json();
      // Sort alphabetically
      return data.sort((a: Department, b: Department) =>
        a.name.localeCompare(b.name)
      );
    } catch (error) {
      console.error("Error fetching departments:", error);
      return [];
    }
  },

  getCities: async (departmentId: number): Promise<City[]> => {
    if (!departmentId) return [];
    try {
      const response = await fetch(
        `${API_URL}/Department/${departmentId}/cities`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch cities");
      }
      const data = await response.json();
      // Sort alphabetically
      return data.sort((a: City, b: City) => a.name.localeCompare(b.name));
    } catch (error) {
      console.error("Error fetching cities:", error);
      return [];
    }
  },
};
